/**
 * Formato de fechas del panel.
 *
 * Los timestamps de la API llegan en ISO 8601 (UTC); aquí se pintan en el locale del negocio
 * (`es-CO`): "16 sept 2026". Si el valor viene vacío o no es una fecha válida se pinta "—" en
 * vez de "Invalid Date" (los `createdAt`/`updatedAt` son opcionales en algunas respuestas).
 */

const LOCALE = 'es-CO';

/** "16 sept 2026" (o "—" si no hay fecha utilizable). */
export function formatDate(value: string | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';

  return date.toLocaleDateString(LOCALE, { day: '2-digit', month: 'short', year: 'numeric' });
}

/** "16 sept 2026, 14:05". */
export function formatDateTime(value: string | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';

  return date.toLocaleString(LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;

  const date = typeof value === 'string' ? new Date(value) : value;
  return Number.isNaN(date.getTime()) ? null : date;
}
